export default __webpack_public_path__ + "static/home-v2-8730f34fabe069ed4759fa7e11cb7b51.png";